var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ContentWrapper",
    [
      _c("div", { staticClass: "content-heading" }, [
        _c("div", [
          _vm._v(_vm._s("메시지 " + (_vm.info.msgSeq == 0 ? "등록" : "수정")))
        ]),
        _c("ol", { staticClass: "breadcrumb ml-auto" }, [
          _c("li", { staticClass: "breadcrumb-item" }, [
            _c("a", { attrs: { href: "#" } }, [_vm._v("Home")])
          ]),
          _c("li", { staticClass: "breadcrumb-item" }, [
            _vm._v("\n          마켓팅 관리\n        ")
          ]),
          _c("li", { staticClass: "breadcrumb-item active" }, [
            _c("a", { attrs: { href: _vm.page.prevUrl } }, [
              _vm._v(_vm._s(_vm.page.prevTitle))
            ])
          ])
        ])
      ]),
      _c("div", { staticClass: "card card-default book-list" }, [
        _c(
          "div",
          {
            staticClass: "card-body",
            staticStyle: { "background-color": "#fff" }
          },
          [
            _c("form", { attrs: { "data-vv-scope": "edit" } }, [
              _c("table", { staticClass: "table table-bordered table-hover" }, [
                _c("colgroup", [
                  _c("col", { attrs: { width: "12%" } }),
                  _c("col", { attrs: { width: "38%" } }),
                  _c("col", { attrs: { width: "12%" } }),
                  _c("col", { attrs: { width: "38%" } })
                ]),
                _c("tbody", [
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("분류*")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle text-center" },
                      [
                        _c("b-form-select", {
                          staticClass: "custom-select custom-select-sm mt-1",
                          attrs: {
                            options: _vm.page.categoryOption.noEmptyArray
                          },
                          model: {
                            value: _vm.info.msgCateCd,
                            callback: function($$v) {
                              _vm.$set(_vm.info, "msgCateCd", $$v)
                            },
                            expression: "info.msgCateCd"
                          }
                        })
                      ],
                      1
                    ),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("유형*")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle" },
                      [
                        _c("b-form-radio-group", {
                          staticClass: "mt-2 mb-1",
                          attrs: {
                            disabled: _vm.page.msgSelectTypeCd != "",
                            options: _vm.data.sendTypeOption.noEmptyArray,
                            "value-field": "value",
                            "text-field": "text",
                            "disabled-field": "notEnabled"
                          },
                          model: {
                            value: _vm.info.sendTypeCd,
                            callback: function($$v) {
                              _vm.$set(_vm.info, "sendTypeCd", $$v)
                            },
                            expression: "info.sendTypeCd"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("예약발송*")
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _c("div", { staticClass: "no-margin row" }, [
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("datepicker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "is-invalid": _vm.errors.has("edit.sendDate")
                              },
                              attrs: {
                                disabled: _vm.info.sendNow == "Y",
                                format: "yyyy-MM-dd",
                                bootstrapStyling: true,
                                "monday-first": true,
                                "full-month-name": true,
                                placeholder: "날짜 선택",
                                "calendar-button": true,
                                "calendar-button-icon": "far fa-calendar",
                                "clear-button": false,
                                name: "sendDate",
                                width: "300px"
                              },
                              model: {
                                value: _vm.page.sendDate,
                                callback: function($$v) {
                                  _vm.$set(_vm.page, "sendDate", $$v)
                                },
                                expression: "page.sendDate"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("b-form-timepicker", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              class: {
                                "is-invalid": _vm.errors.has("edit.sendTime")
                              },
                              attrs: {
                                disabled: _vm.info.sendNow == "Y",
                                placeholder: "시간 선택",
                                name: "sendTime"
                              },
                              model: {
                                value: _vm.page.sendTime,
                                callback: function($$v) {
                                  _vm.$set(_vm.page, "sendTime", $$v)
                                },
                                expression: "page.sendTime"
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-auto" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.info.sendNow,
                                expression: "info.sendNow"
                              }
                            ],
                            attrs: {
                              type: "checkbox",
                              id: "sendNow",
                              "true-value": "Y",
                              "false-value": "N"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.info.sendNow)
                                ? _vm._i(_vm.info.sendNow, null) > -1
                                : _vm._q(_vm.info.sendNow, "Y")
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.info.sendNow,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.info,
                                        "sendNow",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.info,
                                        "sendNow",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.info, "sendNow", $$c)
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "font-weight-bold ml-1 mr-1",
                              attrs: { for: "sendNow" }
                            },
                            [_vm._v("즉시")]
                          )
                        ])
                      ])
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("대상선정 방식*")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle" },
                      [
                        _c("b-form-radio-group", {
                          staticClass: "mt-2 mb-1",
                          attrs: {
                            options: _vm.page.selectTypeOption.array,
                            "value-field": "value",
                            "text-field": "text",
                            "disabled-field": "notEnabled"
                          },
                          model: {
                            value: _vm.info.msgSelectTypeCd,
                            callback: function($$v) {
                              _vm.$set(_vm.info, "msgSelectTypeCd", $$v)
                            },
                            expression: "info.msgSelectTypeCd"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("제목*")
                    ]),
                    _c(
                      "td",
                      {
                        staticClass: "align-middle text-center",
                        attrs: { colspan: "3" }
                      },
                      [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.info.title,
                              expression: "info.title"
                            },
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required|min:2",
                              expression: "'required|min:2'"
                            }
                          ],
                          class: {
                            "form-control": true,
                            "is-invalid": _vm.errors.has("edit.title")
                          },
                          staticStyle: { width: "100%" },
                          attrs: { type: "text", name: "title" },
                          domProps: { value: _vm.info.title },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) {
                                return
                              }
                              _vm.$set(_vm.info, "title", $event.target.value)
                            }
                          }
                        })
                      ]
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("내용*")
                    ]),
                    _c(
                      "td",
                      { staticClass: "align-middle", attrs: { colspan: "3" } },
                      [
                        _vm.info.sendTypeCd == "318001"
                          ? _c("b-form-select", {
                              staticClass:
                                "custom-select custom-select-sm mt-1 mb-2",
                              staticStyle: { width: "300px" },
                              attrs: { options: _vm.page.emailFormatOption },
                              on: {
                                change: function($event) {
                                  return _vm.emailFormatChanged()
                                }
                              },
                              model: {
                                value: _vm.page.emailFormat,
                                callback: function($$v) {
                                  _vm.$set(_vm.page, "emailFormat", $$v)
                                },
                                expression: "page.emailFormat"
                              }
                            })
                          : _vm._e(),
                        _vm.info.sendTypeCd == "318001"
                          ? _c("jodit-editor", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:10",
                                  expression: "'required|min:10'"
                                }
                              ],
                              class: {
                                "is-invalid": _vm.errors.has("edit.msgEmail")
                              },
                              style: "min-height:300px;",
                              attrs: {
                                id: "jodit_edit",
                                config: _vm.jodit_config.config,
                                buttons: _vm.jodit_config.buttons,
                                plugins: _vm.jodit_config.plugins,
                                name: "msgEmail"
                              },
                              model: {
                                value: _vm.info.msg,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "msg", $$v)
                                },
                                expression: "info.msg"
                              }
                            })
                          : _vm._e(),
                        _vm.info.sendTypeCd == "318002" ||
                        _vm.info.sendTypeCd == "318004"
                          ? _c("b-form-textarea", {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:2",
                                  expression: "'required|min:2'"
                                }
                              ],
                              class: {
                                "form-control": true,
                                "is-invalid": _vm.errors.has("edit.msgSms")
                              },
                              attrs: {
                                id: "textarea",
                                placeholder: "내용을 입력해주세요.",
                                name: "msgSms",
                                rows: "5",
                                "max-rows": "10"
                              },
                              model: {
                                value: _vm.info.msg,
                                callback: function($$v) {
                                  _vm.$set(_vm.info, "msg", $$v)
                                },
                                expression: "info.msg"
                              }
                            })
                          : _vm._e(),
                        _vm.info.sendTypeCd == "318002"
                          ? _c("span", [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm.page.msgByteCount) +
                                  " byte(*80byte 초과 시, LMS/MMS로 발송됩니다.)\n                "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("등록자 ID")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.info.regId) +
                          "\n              "
                      )
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("등록일시")
                    ]),
                    _c("td", { staticClass: "align-middle " }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.info.regDt) +
                          "\n              "
                      )
                    ])
                  ]),
                  _c("tr", [
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("수정자 ID")
                    ]),
                    _c("td", { staticClass: "align-middle" }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.info.updId) +
                          "\n              "
                      )
                    ]),
                    _c("td", { staticClass: "align-middle text-center" }, [
                      _vm._v("수정일시")
                    ]),
                    _c("td", { staticClass: "align-middle " }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm.info.updDt) +
                          "\n              "
                      )
                    ])
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "footer mt-3" }, [
              _c(
                "div",
                { staticClass: "float-right" },
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-b btn-info mr-2",
                      attrs: { variant: "info mr-2" },
                      on: {
                        click: function($event) {
                          return _vm.saveAndShowMessageTarget()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.info.msgSeq == 0 ? "저장" : "수정"))]
                  ),
                  _c(
                    "b-button",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.info.msgSeq != 0,
                          expression: "info.msgSeq != 0"
                        }
                      ],
                      staticClass: "btn btn-b btn-outline-danger mr-2",
                      attrs: { variant: "outline-info mr-2" },
                      on: {
                        click: function($event) {
                          return _vm.remove()
                        }
                      }
                    },
                    [_vm._v("삭제")]
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "btn btn-b btn-outline-info mr-2",
                      attrs: { variant: "outline-info mr-2" },
                      on: {
                        click: function($event) {
                          return _vm.list()
                        }
                      }
                    },
                    [_vm._v("목록")]
                  )
                ],
                1
              )
            ])
          ]
        )
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page.msgSelectTypeCd,
              expression: "page.msgSelectTypeCd"
            }
          ],
          staticClass: "card card-default book-list"
        },
        [
          _c(
            "div",
            { staticClass: "card-header mt-2" },
            [
              _c("span", { staticClass: "text-bold h4" }, [
                _vm._v("발송대상 검색")
              ]),
              _c(
                "div",
                { staticClass: "card-tool float-right" },
                [
                  _vm.page.msgSelectTypeCd == "108002"
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "btn btn-sm btn-outline-info mr-2",
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function($event) {
                              return _vm.downloadTemplate()
                            }
                          }
                        },
                        [_vm._v("템플릿 다운로드")]
                      )
                    : _vm._e(),
                  _vm.page.msgSelectTypeCd == "108002"
                    ? _c(
                        "b-btn",
                        {
                          staticClass: "btn btn-sm btn-outline-info mr-2",
                          attrs: { variant: "outline-primary" },
                          on: {
                            click: function($event) {
                              return _vm.addToTempMembersExcel()
                            }
                          }
                        },
                        [_vm._v("파일 선택")]
                      )
                    : _vm._e(),
                  _c("input", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: false,
                        expression: "false"
                      }
                    ],
                    ref: "fileInput",
                    attrs: {
                      type: "file",
                      accept:
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                    },
                    on: { change: _vm.readTempMembersExcel }
                  }),
                  _c(
                    "b-btn",
                    {
                      staticClass: "btn btn-sm btn-outline-info mr-2",
                      attrs: { variant: "outline-primary" },
                      on: {
                        click: function($event) {
                          $event.preventDefault()
                          return _vm.openMemberSearchPopup()
                        }
                      }
                    },
                    [_vm._v("회원 ID/이름 검색")]
                  ),
                  _c(
                    "b-btn",
                    {
                      staticClass: "btn btn-sm btn-outline-info mr-2",
                      attrs: { variant: "outline-danger" },
                      on: {
                        click: function($event) {
                          return _vm.saveWithSendMembers()
                        }
                      }
                    },
                    [_vm._v("발송대상 등록")]
                  )
                ],
                1
              ),
              _vm.page.msgSelectTypeCd == "108001" ||
              (_vm.page.msgSelectTypeCd == "108002" &&
                _vm.info.sendTypeCd != "318002" &&
                  _vm.info.sendTypeCd != "318001")
                ? _c(
                    "div",
                    {
                      staticClass: "form-group mt-3 pl-2",
                      staticStyle: { border: "1px solid #23b7e5" }
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "form-group row mt-3",
                          staticStyle: { width: "100%" }
                        },
                        [
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("회원 유형")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c(
                                "b-input-group",
                                { staticClass: "mt-2 mb-1" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "form-check mb-2" },
                                    [
                                      _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.data.selectAllUserType,
                                            expression: "data.selectAllUserType"
                                          }
                                        ],
                                        staticClass: "form-check-input",
                                        attrs: {
                                          id: "user-type-all",
                                          value: "",
                                          type: "checkbox"
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.data.selectAllUserType
                                          )
                                            ? _vm._i(
                                                _vm.data.selectAllUserType,
                                                ""
                                              ) > -1
                                            : _vm.data.selectAllUserType
                                        },
                                        on: {
                                          change: function($event) {
                                            var $$a =
                                                _vm.data.selectAllUserType,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = "",
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.data,
                                                    "selectAllUserType",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.data,
                                                    "selectAllUserType",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.data,
                                                "selectAllUserType",
                                                $$c
                                              )
                                            }
                                          }
                                        }
                                      }),
                                      _c(
                                        "label",
                                        {
                                          staticClass: "form-check-label",
                                          attrs: { for: "user-type-all" }
                                        },
                                        [_vm._v("전체")]
                                      )
                                    ]
                                  ),
                                  _vm._l(
                                    _vm.page.userTypeOption.noEmptyArray,
                                    function(item, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "form-check mb-2 ml-3"
                                        },
                                        [
                                          _c("input", {
                                            directives: [
                                              {
                                                name: "model",
                                                rawName: "v-model",
                                                value:
                                                  _vm.data.selectedUserTypes,
                                                expression:
                                                  "data.selectedUserTypes"
                                              }
                                            ],
                                            staticClass: "form-check-input",
                                            attrs: {
                                              id: "user-type-" + index,
                                              type: "checkbox"
                                            },
                                            domProps: {
                                              value: item.value,
                                              checked: Array.isArray(
                                                _vm.data.selectedUserTypes
                                              )
                                                ? _vm._i(
                                                    _vm.data.selectedUserTypes,
                                                    item.value
                                                  ) > -1
                                                : _vm.data.selectedUserTypes
                                            },
                                            on: {
                                              change: function($event) {
                                                var $$a =
                                                    _vm.data.selectedUserTypes,
                                                  $$el = $event.target,
                                                  $$c = $$el.checked
                                                    ? true
                                                    : false
                                                if (Array.isArray($$a)) {
                                                  var $$v = item.value,
                                                    $$i = _vm._i($$a, $$v)
                                                  if ($$el.checked) {
                                                    $$i < 0 &&
                                                      _vm.$set(
                                                        _vm.data,
                                                        "selectedUserTypes",
                                                        $$a.concat([$$v])
                                                      )
                                                  } else {
                                                    $$i > -1 &&
                                                      _vm.$set(
                                                        _vm.data,
                                                        "selectedUserTypes",
                                                        $$a
                                                          .slice(0, $$i)
                                                          .concat(
                                                            $$a.slice($$i + 1)
                                                          )
                                                      )
                                                  }
                                                } else {
                                                  _vm.$set(
                                                    _vm.data,
                                                    "selectedUserTypes",
                                                    $$c
                                                  )
                                                }
                                              }
                                            }
                                          }),
                                          _c(
                                            "label",
                                            {
                                              staticClass: "form-check-label",
                                              attrs: {
                                                for: "user-type-" + index
                                              }
                                            },
                                            [_vm._v(_vm._s(item.text))]
                                          )
                                        ]
                                      )
                                    }
                                  )
                                ],
                                2
                              )
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("문자수신 동의")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c("b-form-select", {
                                staticClass: "custom-select custom-select-sm",
                                attrs: { options: _vm.page.useYnOption },
                                model: {
                                  value: _vm.data.params.smsYn,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data.params, "smsYn", $$v)
                                  },
                                  expression: "data.params.smsYn"
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("메일수신 동의")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c("b-form-select", {
                                staticClass: "custom-select custom-select-sm",
                                attrs: { options: _vm.page.useYnOption },
                                model: {
                                  value: _vm.data.params.emailYn,
                                  callback: function($$v) {
                                    _vm.$set(_vm.data.params, "emailYn", $$v)
                                  },
                                  expression: "data.params.emailYn"
                                }
                              })
                            ],
                            1
                          ),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("조건문 추가")
                            ])
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto" },
                            [
                              _c("b-form-input", {
                                attrs: { type: "text" },
                                model: {
                                  value: _vm.data.params.additionalWhere,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data.params,
                                      "additionalWhere",
                                      $$v
                                    )
                                  },
                                  expression: "data.params.additionalWhere"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c("div", { staticClass: "form-group no-margin row" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("학교급")
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("b-form-select", {
                              staticClass: "custom-select custom-select-sm",
                              attrs: {
                                options: _vm.page.schoolGrdCdOption.array,
                                disabled: _vm.data.studentOrParentSelected
                              },
                              on: {
                                change: function($event) {
                                  return _vm.schoolGradeChanged()
                                }
                              },
                              model: {
                                value: _vm.data.params.schlGrdCd,
                                callback: function($$v) {
                                  _vm.$set(_vm.data.params, "schlGrdCd", $$v)
                                },
                                expression: "data.params.schlGrdCd"
                              }
                            })
                          ],
                          1
                        ),
                        _c("div", { staticClass: "col-auto" }, [
                          _c("label", { staticClass: "col-form-label" }, [
                            _vm._v("과목")
                          ])
                        ]),
                        _c(
                          "div",
                          { staticClass: "col-auto" },
                          [
                            _c("b-form-select", {
                              staticClass: "custom-select custom-select-sm",
                              attrs: {
                                options: _vm.page.subjectCdOption,
                                disabled: _vm.data.studentOrParentSelected
                              },
                              model: {
                                value: _vm.data.params.subjectCd,
                                callback: function($$v) {
                                  _vm.$set(_vm.data.params, "subjectCd", $$v)
                                },
                                expression: "data.params.subjectCd"
                              }
                            })
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "col-auto ml-5" },
                          [
                            _c(
                              "b-btn",
                              {
                                staticClass: "btn btn-sm btn-outline-info",
                                attrs: { variant: "outline-primary" },
                                on: {
                                  click: function($event) {
                                    return _vm.searchUser()
                                  }
                                }
                              },
                              [_vm._v("검색")]
                            )
                          ],
                          1
                        )
                      ])
                    ]
                  )
                : _vm._e(),
              _vm.page.msgSelectTypeCd == "108002" &&
              (_vm.info.sendTypeCd == "318002" ||
                _vm.info.sendTypeCd == "318001")
                ? _c(
                    "div",
                    {
                      staticClass: "form-group mt-3 pl-2",
                      staticStyle: { border: "1px solid #23b7e5" }
                    },
                    [
                      _c("div", { staticClass: "form-group row mt-2" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c("span", { staticClass: "text-bold h4" }, [
                            _vm._v("비회원 개별 등록")
                          ])
                        ])
                      ]),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.info.sendTypeCd == "318002",
                              expression: "info.sendTypeCd=='318002'"
                            }
                          ],
                          staticClass: "form-group no-margin row"
                        },
                        [
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("이름")
                            ])
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.noMember.name,
                                  expression: "data.noMember.name"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:2",
                                  expression: "'required|min:2'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("sms.name")
                              },
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "text",
                                "data-vv-scope": "sms",
                                name: "name"
                              },
                              domProps: { value: _vm.data.noMember.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data.noMember,
                                    "name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("휴대폰")
                            ])
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.noMember.phone,
                                  expression: "data.noMember.phone"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: {
                                    required: true,
                                    regex: /^(^02.{0}|^01.{1}|[0-9]{3})([0-9]{3,4})([0-9]{4})$/
                                  },
                                  expression:
                                    "{required:true, regex:/^(^02.{0}|^01.{1}|[0-9]{3})([0-9]{3,4})([0-9]{4})$/}"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("sms.phone")
                              },
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "text",
                                "data-vv-scope": "sms",
                                name: "phone"
                              },
                              domProps: { value: _vm.data.noMember.phone },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data.noMember,
                                    "phone",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto ml-5" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "btn btn-sm btn-outline-info",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.addNoMember("sms")
                                    }
                                  }
                                },
                                [_vm._v("추가")]
                              )
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.info.sendTypeCd == "318001",
                              expression: "info.sendTypeCd=='318001'"
                            }
                          ],
                          staticClass: "form-group no-margin row"
                        },
                        [
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("이름")
                            ])
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.noMember.name,
                                  expression: "data.noMember.name"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|min:2",
                                  expression: "'required|min:2'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("email.name")
                              },
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "text",
                                "data-vv-scope": "email",
                                name: "name"
                              },
                              domProps: { value: _vm.data.noMember.name },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data.noMember,
                                    "name",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("label", { staticClass: "col-form-label" }, [
                              _vm._v("이메일")
                            ])
                          ]),
                          _c("div", { staticClass: "col-auto" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.data.noMember.email,
                                  expression: "data.noMember.email"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|email",
                                  expression: "'required|email'"
                                }
                              ],
                              staticClass: "form-control",
                              class: {
                                "is-invalid": _vm.errors.has("email.email")
                              },
                              staticStyle: { width: "200px" },
                              attrs: {
                                type: "text",
                                "data-vv-scope": "email",
                                name: "email"
                              },
                              domProps: { value: _vm.data.noMember.email },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.$set(
                                    _vm.data.noMember,
                                    "email",
                                    $event.target.value
                                  )
                                }
                              }
                            })
                          ]),
                          _c(
                            "div",
                            { staticClass: "col-auto ml-5" },
                            [
                              _c(
                                "b-btn",
                                {
                                  staticClass: "btn btn-sm btn-outline-info",
                                  attrs: { variant: "outline-primary" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.addNoMember("email")
                                    }
                                  }
                                },
                                [_vm._v("추가")]
                              )
                            ],
                            1
                          )
                        ]
                      )
                    ]
                  )
                : _vm._e(),
              _c("span", { staticClass: "text-bold h5" }, [
                _vm._v("조회 결과 총 " + _vm._s(_vm.data.count) + "명")
              ]),
              _c("ShowCounter", {
                staticClass: "ml-1",
                attrs: { label: "Show", data: _vm.data },
                on: { search: _vm.searchTemp }
              }),
              _c(
                "table",
                {
                  staticClass: "table table-striped table-bordered table-hover"
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "4%" }
                        },
                        [_vm._v("No")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("이름")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("회원ID")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("회원유형")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("휴대폰")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("문자수신 동의")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("이메일")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("메일수신 동의")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("삭제")]
                      )
                    ])
                  ]),
                  _c(
                    "tbody",
                    [
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.data.count == 0,
                              expression: "data.count==0"
                            }
                          ],
                          staticClass: "text-center"
                        },
                        [
                          _c("td", { attrs: { colspan: "9" } }, [
                            _vm._v("No matching records")
                          ])
                        ]
                      ),
                      _vm._l(_vm.data.list, function(item, index) {
                        return [
                          _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.data.params.limit *
                                      (_vm.data.params.page - 1) +
                                      index +
                                      1
                                  )
                                )
                              ]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.maskedLoginId))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.page.userTypeOption.getUserTypeText(
                                      item.typeCd
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.phone))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.smsYn))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.email))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.emailYn))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn btn-danger",
                                    on: {
                                      click: function($event) {
                                        return _vm.removeFromTempMembers(
                                          item.loginId,
                                          item.noMemberId
                                        )
                                      }
                                    }
                                  },
                                  [_vm._v("삭제")]
                                )
                              ]
                            )
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "form-group no-margin row mt-2",
                  staticStyle: { width: "100%" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "col-auto" },
                    [
                      _c("b-input-group", { staticClass: "mt-2" }, [
                        _c("div", { staticClass: "form-check" }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.page.forceSendYn,
                                expression: "page.forceSendYn"
                              }
                            ],
                            staticClass: "form-check-input",
                            attrs: {
                              id: "sendForce",
                              "true-value": "Y",
                              "false-value": "N",
                              type: "checkbox"
                            },
                            domProps: {
                              checked: Array.isArray(_vm.page.forceSendYn)
                                ? _vm._i(_vm.page.forceSendYn, null) > -1
                                : _vm._q(_vm.page.forceSendYn, "Y")
                            },
                            on: {
                              change: function($event) {
                                var $$a = _vm.page.forceSendYn,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? "Y" : "N"
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.page,
                                        "forceSendYn",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.page,
                                        "forceSendYn",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.page, "forceSendYn", $$c)
                                }
                              }
                            }
                          }),
                          _c(
                            "label",
                            {
                              staticClass: "form-check-label",
                              attrs: { for: "sendForce" }
                            },
                            [_vm._v("강제발송 (마켓팅 수신동의 관계없이 발송)")]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex" },
                [
                  _c("Pagenation", {
                    key: _vm.data.params.page,
                    attrs: { data: _vm.data },
                    on: {
                      next: function($event) {
                        return _vm.dataAction.next(_vm.searchTemp)
                      },
                      prev: function($event) {
                        return _vm.dataAction.prev(_vm.searchTemp)
                      },
                      first: function($event) {
                        return _vm.dataAction.first(_vm.searchTemp)
                      },
                      last: function($event) {
                        return _vm.dataAction.last(_vm.searchTemp)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.page.msgSelectTypeCd,
              expression: "page.msgSelectTypeCd"
            }
          ],
          staticClass: "card card-default book-list"
        },
        [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("span", { staticClass: "text-bold h4" }, [_vm._v("발송대상")]),
              _c("ShowCounter", {
                staticClass: "ml-1 mt-1",
                attrs: { label: "Show", data: _vm.sendData },
                on: { search: _vm.searchSend }
              }),
              _c(
                "table",
                {
                  staticClass: "table table-striped table-bordered table-hover"
                },
                [
                  _c("thead", [
                    _c("tr", [
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "4%" }
                        },
                        [_vm._v("No")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("이름")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("회원ID")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("회원유형")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("휴대폰")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("문자수신 동의")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("이메일")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("메일수신 동의")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("강제 발송")]
                      ),
                      _c(
                        "td",
                        {
                          staticStyle: { "text-align": "center" },
                          attrs: { width: "10%" }
                        },
                        [_vm._v("등록 일시")]
                      )
                    ])
                  ]),
                  _c(
                    "tbody",
                    [
                      _c(
                        "tr",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.sendData.count == 0,
                              expression: "sendData.count==0"
                            }
                          ],
                          staticClass: "text-center"
                        },
                        [
                          _c("td", { attrs: { colspan: "10" } }, [
                            _vm._v("발송대상 회원이 없습니다.")
                          ])
                        ]
                      ),
                      _vm._l(_vm.sendData.list, function(item, index) {
                        return [
                          _c("tr", { key: index }, [
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.sendData.params.limit *
                                      (_vm.sendData.params.page - 1) +
                                      index +
                                      1
                                  )
                                )
                              ]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.name))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.maskedLoginId))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.page.userTypeOption.getUserTypeText(
                                      item.typeCd
                                    )
                                  )
                                )
                              ]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.phone))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.smsYn))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.email))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.emailYn))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.forceSendYn))]
                            ),
                            _c(
                              "td",
                              { staticClass: "align-middle text-center" },
                              [_vm._v(_vm._s(item.regDt))]
                            )
                          ])
                        ]
                      })
                    ],
                    2
                  )
                ]
              ),
              _c(
                "div",
                { staticClass: "d-flex mt-2" },
                [
                  _c("Pagenation", {
                    attrs: { data: _vm.sendData },
                    on: {
                      next: function($event) {
                        return _vm.sendDataAction.next(_vm.searchSend)
                      },
                      prev: function($event) {
                        return _vm.sendDataAction.prev(_vm.searchSend)
                      },
                      first: function($event) {
                        return _vm.sendDataAction.first(_vm.searchSend)
                      },
                      last: function($event) {
                        return _vm.sendDataAction.last(_vm.searchSend)
                      }
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      ),
      _c(
        "b-modal",
        {
          attrs: { size: "lg", "hide-footer": "" },
          scopedSlots: _vm._u([
            {
              key: "modal-title",
              fn: function() {
                return [
                  _c("span", { staticClass: "text-bold h4" }, [
                    _vm._v("회원 조회")
                  ])
                ]
              },
              proxy: true
            }
          ]),
          model: {
            value: _vm.page.showMemberSearchPopup,
            callback: function($$v) {
              _vm.$set(_vm.page, "showMemberSearchPopup", $$v)
            },
            expression: "page.showMemberSearchPopup"
          }
        },
        [
          _c("MemberSearchPopup", {
            on: {
              save: _vm.addToTempMembers,
              close: _vm.closeMemberSearchPopup
            }
          })
        ],
        1
      ),
      _c("loading", {
        attrs: { active: _vm.modalLoading, "is-full-page": true }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }